// The message of a failed generated-client call.
//
// A route's non-2xx body is its own error envelope (`detail.message`) or
// FastAPI's 422 validation body (`detail` is a list of field errors), so the
// backend spec types it as either. This reads whichever arrived.

type ErrorBody = { detail?: unknown } | undefined | null

export function errorDetailMessage(body: ErrorBody, fallback = 'Request failed'): string {
  const detail = body?.detail
  if (Array.isArray(detail)) {
    const first = detail[0] as { msg?: unknown } | undefined
    return typeof first?.msg === 'string' ? first.msg : fallback
  }
  if (detail && typeof detail === 'object' && 'message' in detail) {
    const { message } = detail as { message?: unknown }
    if (typeof message === 'string') return message
  }
  return fallback
}
